import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { SecondaryButton } from "../../components/buttons/SecondaryButton";
import Form from "../../components/inputs/Form";
import Header from "../../components/layout/Header";
import { Page, PageBody, PageHeader } from "../../components/layout/Page";
import { backArrow, save } from "../../assets/icons";
import Card from "../../components/card/Card";
import "./client.css";
import { TextInput } from "../../components/inputs/TextInput";
import { useState } from "react";
import { Data } from "../../lib/typeDeclarations";
import { pattern } from "../../lib/pattern";
import { createRecord } from "../../server/fetchFunctions";
import { format } from "../../lib/inputFormatters";
import { Autocomplete } from "../../components/inputs/Autocomplete";
import { useListRecords } from "../../server/hooks/getData";

export default function NewClient() {
  document.title = "Új ügyfél";
  const navigate = useNavigate();

  const [client, setClinet] = useState<Data>({
    name: "",
    vat: "",
    zip: "",
    city: "",
    street: "",
  });

  const [newContact, setNewContact] = useState<Data>({
    name: "",
    phone: "",
    email: "",
  });

  const { data: zipcodes } = useListRecords("zipcodes", [client.zip], {
    zip: client.zip,
    limit: 10,
  });

  //Functions
  const saveClient = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const clientResponse = await createRecord("clients", client);
    const contact = { ...newContact, client_id: clientResponse.id };
    await createRecord("contacts", contact);
    navigate(`/clients/${clientResponse.id}`);
  };

  const handleAutoClompleteZip = (item: Data) => {
    setClinet((prev) => ({
      ...prev,
      zip: item.zip,
      city: item.city,
    }));
  };

  return (
    <Page>
      <Form onSubmit={(e) => saveClient(e)}>
        <Header>
          <SecondaryButton btn={{ svgBefore: backArrow, text: "Vissza", onClick: () => navigate(-1) }} />
          <PrimaryButton btn={{ svgBefore: save, text: "Ment", type: "submit" }} />
        </Header>
        <PageHeader title="Új ügyfél rögzítése" />
        <PageBody>
          <div className="client">
            <div className="col-1">
              <Card title="Ügyfél">
                <TextInput
                  stateKey="name"
                  inlineLabel="Név"
                  state={client}
                  setState={setClinet}
                  pattern={pattern.normal_text}
                  labelWidth={100}
                  required
                />
                <TextInput
                  stateKey="vat"
                  inlineLabel="Adószám"
                  state={client}
                  setState={setClinet}
                  pattern={pattern.vat}
                  labelWidth={100}
                  format="toVatnumber"
                />
                <Autocomplete
                  state={client}
                  setState={setClinet}
                  stateKey="zip"
                  list={zipcodes.data}
                  listKeys={["zip", "city"]}
                  handleClick={handleAutoClompleteZip}
                  inlineLabel="Ir. szám"
                  labelWidth={100}
                  pattern={pattern.zip}
                  required
                  format="toInteger"
                />
                <TextInput
                  stateKey="city"
                  inlineLabel="Település"
                  state={client}
                  setState={setClinet}
                  pattern={pattern.normal_text}
                  labelWidth={100}
                  required
                />

                <TextInput
                  stateKey="street"
                  inlineLabel="Közterület"
                  state={client}
                  setState={setClinet}
                  pattern={pattern.normal_text}
                  labelWidth={100}
                  required
                />
              </Card>
            </div>
            <div className="col-2">
              <Card title="Kapcsolattartó">
                <TextInput
                  stateKey="name"
                  inlineLabel="Név"
                  state={newContact}
                  setState={setNewContact}
                  pattern={pattern.normal_text}
                  labelWidth={100}
                  required
                />
                <TextInput
                  stateKey="phone"
                  inlineLabel="Telefon"
                  state={newContact}
                  setState={setNewContact}
                  pattern={pattern.phone}
                  labelWidth={100}
                  format="toPhoneNumber"
                  required
                />
                <TextInput
                  type="email"
                  stateKey="email"
                  inlineLabel="E-mail"
                  state={newContact}
                  setState={setNewContact}
                  pattern={pattern.email}
                  labelWidth={100}
                  required
                />
              </Card>
            </div>
          </div>
        </PageBody>
      </Form>
    </Page>
  );
}
